import { GetInvestorListRequest, GetInvestorSingleItemRequest, PatchInvestorRequest } from '@finance-lab/utils/types'
import ApiBase from './Api'

const INVESTOR_API_PATHS = {
    ALL_INVESTORS: '/investors',
    INVESTOR_DETAILS: (id: string) => `/investors/${id}`,
}

const ADMIN_INVESTOR_API_PATHS = {
    ALL_INVESTORS: '/admin/investors',
    UPDATE_INVESTOR: (id: string) => `/admin/investors/${id}`,
    DELETE_INVESTOR: (id: string) => `/admin/investors/${id}`,
}

class InvestorApi extends ApiBase {
    async allInvestors() {
        return this._getRequest<GetInvestorListRequest>(ADMIN_INVESTOR_API_PATHS.ALL_INVESTORS)
    }

    async connectAsInvestorAlias(aliasId: string, investorId: string) {
        return this._patchRequest<PatchInvestorRequest>(ADMIN_INVESTOR_API_PATHS.UPDATE_INVESTOR(investorId), {
            aliasId,
        })
    }

    async setAliasAsToplevelInvestor(aliasId: string, oldInvestorId: string) {
        return this._patchRequest<PatchInvestorRequest>(ADMIN_INVESTOR_API_PATHS.UPDATE_INVESTOR(oldInvestorId), {
            promote: aliasId,
        })
    }

    async setInvestorPrimaryNameFromAlias(investorId: string, aliasId: string) {
        return this._patchRequest<PatchInvestorRequest>(ADMIN_INVESTOR_API_PATHS.UPDATE_INVESTOR(investorId), {
            primary: aliasId,
        })
    }

    async deleteInvestorAndAliases(investorId: string) {
        return this._deleteRequest(ADMIN_INVESTOR_API_PATHS.DELETE_INVESTOR(investorId))
    }

    async getInvestor(id: string) {
        const investor = await this._getRequest<GetInvestorSingleItemRequest>(INVESTOR_API_PATHS.INVESTOR_DETAILS(id))

        return investor
    }
}

export default InvestorApi
